import type { FaireProductEntity } from "../../entity_types/product";

export const p_7qpk3n54c5: FaireProductEntity = {
  token: "p_7qpk3n54c5",
  type: "product",
  name: "Headache Buster Shower Spray - Eucalyptus, Peppermint & Lime",
  brandToken: "b_35vnge4tj4",
  brandName: "Ani’s Market LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/9c583e62ac063e7ef20cda963c8cca077a9f35caadd9308d6f133afc6fecf172.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d306917f0c5b42fc730dd0be10db8cdf4011b49a083ddf8cc6d31524eaea9378.jpeg",
    "https://cdn.faire.com/fastly/18b55cd57b8f22f99e9dd437416e92adf72a1cf1a46a1b36a2a3fa8f231e003a.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "Kiss that headache goodbye with our powerful aromatherapy blend of eucalyptus, peppermint and lime essential oils. Just spray in the shower and feel the invigorating scent and relief wash over you.\n\nDid you know?\n\n~ Eucalyptus essential oil aromatherapy is commonly known to help with headaches, allergies, joint &muscle pain and more.\n~ Peppermint oil aromatherapy is known for treating migraines, colds and coughs, reducing stress and reducing pain.\n~ Lime essential oil has been shown to stimulate the immune system, helping the body fight off infections and illnesses.\n\n\nHow to use: shake the bottle and spray into shower water. Enjoy the aromatherapy as the shower steam mixes with our 100% essential oil blend.\n\nIngredients: 100% Essential oil blend.\n\nNo dyes or colors.\n\nNET WT: 2oz",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:39.841Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
